export default __webpack_public_path__ + "static/media/p2.0168ffc9.jpg";